import React, { useEffect, useState } from "react";
import PageHeader from "../../components/shared/pageHeader/PageHeader";
import { useTranslation } from "react-i18next";
import CustomInputText from "../../components/shared/forms/input/CustomInputText";
import SearchEventsList from "./events/list";
// import SearchCategoriesList from "./categories/list";
import SearchStandsList from "./stands/list";
import SearchUsersList from "./users/list";
import queryString from "query-string";
import firebase from "./../../firebase/firebase";
import { useHistory } from "react-router-dom";
import { DB_COLLECTIONS } from "../../firebase/collections";

declare const $: any;

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

const SearchView = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // Top keywords
  const [topKeywords, setTopKeywords] = useState<string[]>([]);

  // Text input value
  const [query, setQuery] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>("");

  // To track state of various type of search
  const [usersSearch, setUsersSearch] = useState<any>(undefined);
  const [eventsSearch, setEventsSearch] = useState<any>(undefined);
  const [standsSearch, setStandsSearch] = useState<any>(undefined);

  const [timer, setTimer] = useState<any>(undefined);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Load top searched keywords
   * @function
   * @async
   */
  const loadTopKeywords = async () => {
    try {
      const data: string[] = [];
      const snapshot = await firebase
        .firestore()
        .collection(DB_COLLECTIONS.TOP_KEYWORDS)
        .orderBy("count", "desc")
        .limit(20)
        .get();

      snapshot.forEach((doc) => {
        data.push(doc.id);
      });

      setTopKeywords(data);
    } catch (err) {
      console.error(err);
    }
  };

  /**
   * Track searched keywords
   * @function
   * @async
   *
   * @param query
   */
  const trackSearchKeyword = async (query: string) => {
    console.log(`Track ${query} as keyword`);

    try {
      const increment = firebase.firestore.FieldValue.increment(1);

      await firebase
        .firestore()
        .collection(DB_COLLECTIONS.TOP_KEYWORDS)
        .doc(query.toLowerCase())
        .set(
          {
            count: increment,
          },
          { merge: true },
        );
    } catch (err) {
      console.error(err);
    }
  };

  /**
   * Actual search on firestore
   * @function
   *
   * @param query
   */
  const search = (query: string) => {
    setQuery(query);
  };

  /**
   * When user search
   * @function
   *
   * @param value
   * @param time
   */
  const onSearch = (value: string, time: number = 500) => {
    setInputValue(value);

    if (!!timer) {
      clearTimeout(timer);
    }

    setTimer(
      setTimeout(() => {
        search(value);
      }, time),
    );
  };

  /**
   * When results are loaded
   * @function
   *
   * @param found
   * @param type
   */
  const onResults = (found: boolean, type: "stands" | "events" | "users") => {
    if (!!query && query.length >= 3) {
      switch (type) {
        case "stands":
          setStandsSearch({ query, found });
          break;
        case "events":
          setEventsSearch({ query, found });
          break;
        case "users":
          setUsersSearch({ query, found });
          break;
      }
    }
  };

  /**
   * On scroll put searchbox on top fixed
   * @function
   */
  const handleScroll = () => {
    // Scroll
    const searchBox = $(".search-box");

    if (!!searchBox && !!searchBox.length) {
      const offsetTop = searchBox.offset().top;
      const headerHeight = 70;

      const _scroll = (scroll: number) => {
        if (scroll > offsetTop - headerHeight + 20) {
          searchBox.addClass("fixed");
        } else {
          searchBox.removeClass("fixed");
        }
      };

      _scroll($("body").scrollTop());

      $("body").scroll((event: any) => {
        _scroll($("body").scrollTop());
      });
    }
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------
  const renderTopKeywords = () => {
    return (
      <>
        {/* <h5 className="mb-0">
          <i className="fas fa-fire"></i> Trending
        </h5> */}
        <ul className={"tag-list"}>
          {topKeywords.map((key: string) => (
            <li className={query.toLowerCase() === key.toLowerCase() ? "active" : ""} key={key}>
              <a onClick={() => onSearch(key)}>{key}</a>
            </li>
          ))}
        </ul>
      </>
    );
  };

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[SearchView] init");

    loadTopKeywords();

    const params = queryString.parse(history.location.search);

    if (params.query) {
      onSearch(params.query.toString(), 0);
    }

    handleScroll();
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[SearchView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to usersSearch, eventsSearch and standsSearch in order to check if some data was found
   */
  useEffect(() => {
    if (
      !!usersSearch &&
      !!eventsSearch &&
      !!standsSearch &&
      usersSearch.query === eventsSearch.query &&
      usersSearch.query === standsSearch.query
    ) {
      if (!!usersSearch.found || !!eventsSearch.found || !!standsSearch.found) {
        trackSearchKeyword(usersSearch.query);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersSearch, eventsSearch, standsSearch]);

  /**
   * Hook to inputValue in order to reset found items
   */
  useEffect(() => {
    setUsersSearch(undefined);
    setStandsSearch(undefined);
    setEventsSearch(undefined);
  }, [inputValue]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div className={"search-page"}>
        <div className="container">
          <PageHeader title={t("pages.search.title")} description={t("pages.search.description")}/>
        </div>
        <div className="page-content">
          <div className="search-box">
            <div className="container">
              <CustomInputText
                id="search"
                name="search"
                onChange={(evt: any) => onSearch(evt.target.value)}
                value={inputValue}
                placeholder={t("forms.start_typing")}
                onBlur={null}
                errors={null}
                touched={false}
              />
              <i className="fas fa-search"/>
            </div>
          </div>
          <div className="container full-page">
            {renderTopKeywords()}

            <div className="full-page-image">
              <img src="/assets/images/undraw/search.png"/>
            </div>

            <div className="results">
              <SearchStandsList query={query} onResult={onResults}/>
              <SearchUsersList query={query} onResult={onResults}/>
              <SearchEventsList query={query} onResult={onResults}/>
              {/* <SearchCategoriesList query={query} /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SearchView;
